<template>
  <v-layout column class="info-width">
    <!-- MESSAGES -->
    <v-dialog
      v-model="showMessage"
      max-width="390"
      persistent
    >
      <v-card width="390">
        <v-card-title primary-title>
          <div>
            <div class="headline">{{ messageToShow }}</div>
            <span>
              Ésta alarma ha sido justificada por otro usuario.
            </span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="closeMessage"
          >
            <v-icon left>clear</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- JUSTIFICATION COMPONENT -->
    <v-dialog
      v-model="showJustification"
      max-width="390"
      persistent
    >
      <justification-alert
        :alarm='alarmSelected'
        @showDialog='showJustification = false'
        @showMessage='showMessageIn'
      />
    </v-dialog>
    <!-- INFO ALARMS -->
    <v-flex d-inline-flex align-center class="general-info-container" pa-3 mb-1>
      <v-flex style="max-width: 250px; min-width: 250px;">
        <h2>Vehículos Operativos sin Reporte en 72 Horas</h2>
      </v-flex>
      <v-flex
        v-if="!loadingUnreportedEventsAlarms"
        style="max-width: 190px; min-width: 190px;"
      >
        <h3 class="pl-2"><span class="body-2">Total Alarmas:</span> {{ unreportedAlarms.length }}</h3>
      </v-flex>
    </v-flex>
   <!-- HEADER -->
    <v-flex d-flex px-4 py-1 mb-1 class="header-container">
      <v-flex class="cell-width-0 text-xs-left">Quien</v-flex>
      <v-flex class="cell-width-1 text-xs-center">Que</v-flex>
      <v-flex class="cell-width-2 text-xs-center">Desde</v-flex>
      <v-flex class="cell-width-2 text-xs-center">Hasta</v-flex>
      <v-flex class="cell-width-3 text-xs-center">Duración <span class="caption">(h:m:s)</span></v-flex>
      <v-flex class="cell-width-3 text-xs-center" v-if="adminRole === 500 || adminRole === 400">Justificación</v-flex>
    </v-flex>
    <!-- LOADING -->
    <v-flex v-if="loadingUnreportedEventsAlarms" pa-5>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
      Cargando datos...
    </v-flex>
    <!-- CONTENT -->
    <v-flex v-else>
      <!-- ALARM DATA -->
      <v-flex v-if="unreportedAlarms.length > 0">
        <v-expansion-panel focusable>
          <v-expansion-panel-content
            v-for="alarm in unreportedAlarmsThatHaveVehicleInfo"
            :key="alarm.alarmId"
          >
          <!-- HEADER -->
            <template v-slot:header>
              <!-- WHO -->
              <v-flex class="cell-width-0 text-xs-left">
                <v-flex>
                  <v-flex class="small-text">Código/Sigla</v-flex>
                  <v-flex>
                    <b>
                      {{
                        vehicleInfo(alarm.vehicleId).code
                      }}
                    </b>
                  </v-flex>
                </v-flex>
                <v-flex pt-1>
                  <v-flex class="small-text">Placa</v-flex>
                  <v-flex>
                    <b>
                      {{
                        vehicleInfo(alarm.vehicleId).licensePlate
                      }}
                    </b>
                  </v-flex>
                </v-flex>
              </v-flex>
              <!-- WHAT -->
              <v-flex class="cell-width-1 text-xs-center">
                Vehículos Operativos sin Reporte en 72 Horas
              </v-flex>
              <v-flex class="cell-width-2 text-xs-center">
                {{ alarm.initialDate | filterFullDate }}
              </v-flex>
              <v-flex class="cell-width-2 text-xs-center">
                {{ alarm.finalDate | filterFullDate }}
              </v-flex>
              <v-flex class="cell-width-3 text-xs-center">
                {{ duration(alarm.duration) }}
              </v-flex>
              <v-flex v-if="adminRole === 500 || adminRole === 400" class="cell-width-3 text-xs-center">
                <!-- NULL -->
                <v-flex
                  v-if="alarm.justification.isJustified === null"
                  :class="alarm.justification.userInProgressRemote ? 'in-progress-state' : ''"
                  d-inline-flex
                  align-center
                >
                  <v-btn
                    fab
                    small
                    flat
                    :disabled="alarm.justification.justificationInProgress"
                    @click.stop="justifyAlert({
                      alarmId: alarm.alarmId,
                      justification: alarm.justification,
                      licensePlate: vehicleInfo(alarm.vehicleId).licensePlate,
                      code: vehicleInfo(alarm.vehicleId).code
                    })"
                  >
                    <v-icon
                      v-if="alarm.justification.userInProgressRemote"
                      color="grey lighten-1"
                    >
                      textsms
                    </v-icon>
                    <v-icon
                      v-else
                      color="grey lighten-1"
                    >
                      chat_bubble
                    </v-icon>
                  </v-btn>
                  <!-- USER IN PROGRESS -->
                  <v-tooltip
                    left
                    color="amber lighten-2 grey--text text--darken-3"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="alarm.justification.userInProgressRemote"
                        class="hover-icon"
                        style="margin-left:-15px"
                        color="amber"
                        v-on="on"
                      >
                        record_voice_over
                      </v-icon>
                    </template>
                    <span style="color:#424242">
                      ...justificando
                      <br />
                        <b>{{ alarm.justification.userInProgressRemote }}</b>
                    </span>
                  </v-tooltip>
                </v-flex>
                <!-- FALSE -->
                <v-btn
                  v-else-if="alarm.justification.isJustified === false"
                  fab
                  small
                  flat
                  @click.stop="justifyAlert({
                    alarmId: alarm.alarmId,
                    justification: alarm.justification,
                    licensePlate: vehicleInfo(alarm.vehicleId).licensePlate,
                    code: vehicleInfo(alarm.vehicleId).code
                  })"
                >
                  <v-icon color="error">report_off</v-icon>
                </v-btn>
                <!-- TRUE -->
                <v-btn
                  v-else-if="alarm.justification.isJustified === true"
                  fab
                  small
                  flat
                  @click.stop="justifyAlert({
                    alarmId: alarm.alarmId,
                    justification: alarm.justification,
                    licensePlate: vehicleInfo(alarm.vehicleId).licensePlate,
                    code: vehicleInfo(alarm.vehicleId).code
                  })"
                >
                  <v-icon color="success">message</v-icon>
                </v-btn>
              </v-flex>
            </template>
            <!-- CONTENT -->
            <v-card class="pt-3" color="grey darken-4">
              <v-card-text>
                <v-flex d-inline-flex pl-5>
                  <v-flex class="text-xs-center">
                    <router-link :to="`/vehicles/${alarm.vehicleId}`">
                      <VAvatar
                        size="50"
                        color="grey">
                        <v-icon dark large>directions_car</v-icon>
                      </VAvatar>
                      <br>
                      Ver Vehículo
                    </router-link>
                    <v-flex>
                      <v-flex class="small-text">Código/Sigla</v-flex>
                      <v-flex><b>{{ vehicleInfo(alarm.vehicleId).code }}</b></v-flex>
                      <v-flex class="small-text">Placa</v-flex>
                      <v-flex><b>{{ vehicleInfo(alarm.vehicleId).licensePlate }}</b></v-flex>
                      <v-flex class="small-text">Agencia</v-flex>
                      <v-flex><b>{{ vehicleInfo(alarm.vehicleId).agencyId | agencyName }}</b></v-flex>
                    </v-flex>
                  </v-flex>
                  <!-- INFO ALARM -->
                  <v-flex v-if="alarm.stoppedVehicles.length > 0">
                    <v-flex
                      class="body-2 grey--text"
                      d-flex
                      pl-5
                    >
                      <v-flex pl-3>
                        <b>Fecha | Hora</b>
                      </v-flex>
                      <v-flex>
                        <b>Descripción</b>
                      </v-flex>
                    </v-flex>
                    <v-flex
                      v-for="(info, index) in alarm.stoppedVehicles"
                      :key="index"
                      pl-5
                    >
                      <v-flex
                        d-flex
                        align-center
                        :class="[index % 2 ? '' : rowbg]"
                        class="info-vehicle-in caption"
                        px-2
                        py-1
                      >
                        <v-flex>
                          {{ info.time | filterFullDate }}
                        </v-flex>
                        <v-flex pl-5>
                          {{ info.description }}
                        </v-flex>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                  <v-flex class="subheading" v-else pl-5 pt-5>
                    Sin confirmación de novedades del dispositivo
                  </v-flex>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <!-- MESSAGE -->
      <v-flex v-else px-3 py-3>
        <h2>En éste momento no hay alarmas por vehículos operativos sin reporte en 72 horas.</h2>
        <p>A medida que se generen nuevas alarmas, éstas se cargaran automáticamente.</p>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import JustificationAlert from '../components/JustificationAlert'
  import { convertMilliseconds } from '../utils/convertMilliseconds'

  export default {
    name: 'unreported-events-alerts',
    components: {
      JustificationAlert
    },
    data() {
      return {
        intervalUnreportedEventsAlarmsInstance: null,
        intervalUnreportedEventsAlarmsValue: 40000,
        rowbg: 'bg-row',
        alarmSelected: {},
        showJustification: false,
        showMessage: false,
        messageToShow: ''
      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole',
        user: 'auth/getProfile'
      }),
      ...mapGetters([
        'pusherRef',
        'vehicleInfo',
        'unreportedAlarms',
        'loadingUnreportedEventsAlarms'
      ]),
      unreportedAlarmsThatHaveVehicleInfo() {
        return this.unreportedAlarms.filter(alarm => {
          return !!this.vehicleInfo(alarm.vehicleId)
        })
      }
    },
    methods: {
      ...mapActions([
        'clearUnreportedEventsAlarms',
        'setLoadingUnreportedEventsAlarms',
        'fetchUnreportedEventsAlarms'
      ]),
      intervalForUnreportedEventsAlarms() {
        this.intervalUnreportedEventsAlarmsInstance = setInterval(() => {
          this.fetchUnreportedEventsAlarms()
        }, this.intervalUnreportedEventsAlarmsValue)
      },
      justifyAlert(alarm) {
        if (alarm.justification.isJustified === null) {
          // console.log('CHANNELS', this.pusherRef)
          const channel = this.pusherRef.channels.channels['presence-justification-in-progress']
          // console.log('CHANNEL', channel)
          channel.trigger(
            'client-justification-in-progress',
            {
              i: alarm.alarmId,
              t: 'unreported',
              v: true,
              u: this.user.name
            }
          )
        }

        // console.log('ALARM', alarm)
        const type = 'unreported'
        this.alarmSelected = {
          ...alarm.justification,
          alarmId: alarm.alarmId,
          licensePlate: alarm.licensePlate,
          code: alarm.code,
          type
        }
        // console.log('alarmSelected', this.alarmSelected)
        this.showJustification = true
      },
      duration(value) {
        const milliseconds = value * 1000
        let result = convertMilliseconds(milliseconds, 'hh:mm:ss')
        return result.clock
      },
      showMessageIn(data) {
        this.messageToShow = data.message
        this.showMessage = true
      },
      closeMessage() {
        this.messageToShow = ''
        this.showMessage = false
      }
    },
    mounted() {
      this.setLoadingUnreportedEventsAlarms(true)
      this.fetchUnreportedEventsAlarms()
      this.intervalForUnreportedEventsAlarms()
    },
    beforeDestroy() {
      clearInterval(this.intervalUnreportedEventsAlarmsInstance)
      this.clearUnreportedEventsAlarms()
    }
  }
</script>

<style lang="stylus" scoped>
a
  text-decoration none
  color white
  font-size 16px

a:hover
  opacity 0.7

.info-vehicle-in
  height 24px

.bg-row
  background-color rgba(255, 255, 255, 0.07)
  border-radius 2px

.small-text
  font-size 8px

.header-container
  min-width 960px
  max-width 1024px
  height 35px
  border-radius 3px
  background-color #424242
  font-size 16px
  font-weight 500

.cell-width-0
  min-width 120px
  max-width 120px

.cell-width-1
  min-width 180px
  max-width 180px

.cell-width-2
  min-width 190px
  max-width 190px

.cell-width-3
  min-width 140px
  max-width 140px

.general-info-container
  height 70px
  border-radius 3px
  background-color #424242

.info-width
  min-width 960px
  max-width 1024px

.hover-icon:hover
  cursor: pointer

.in-progress-state
  border dashed 1px #FFD54F
  border-radius 10px
  max-width 85px
  min-width 85px
  max-height 50px
  min-height 50px
  margin-left -15px
  padding-right 15px
</style>



// WEBPACK FOOTER //
// src/components/UnreportedEventsAlerts.vue